import firebase from './firebase';

/**
 * reCAPTCHA Enterprise site key (key ID) from Google Cloud reCAPTCHA Enterprise,
 * registered for this web app in Firebase Console → App Check.
 * https://firebase.google.com/docs/app-check/web/recaptcha-enterprise-provider
 */
const RECAPTCHA_ENTERPRISE_SITE_KEY =
  '6LfzHbAsAAAAAHQamZaK1yYsVNpB9pPpsCjE6DKM';

let activated = false;

/**
 * Enable Firebase App Check with reCAPTCHA Enterprise (invisible / score-based).
 * Idempotent; safe to call once per page after Firebase app exists.
 */
export function activateAppCheck(firebaseApp) {
  if (activated || typeof window === 'undefined') {
    return;
  }
  const siteKey = RECAPTCHA_ENTERPRISE_SITE_KEY;
  if (!siteKey) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(
        '[App Check] RECAPTCHA_ENTERPRISE_SITE_KEY is empty in appCheck.js; App Check not activated.',
      );
    }
    return;
  }

  if (
    typeof window !== 'undefined' &&
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_APPCHECK_DEBUG === 'true'
  ) {
    // Print a debug token to register in Firebase console for localhost/CI.
    // https://firebase.google.com/docs/app-check/web/debug-provider
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  try {
    const appCheck = firebase.appCheck(firebaseApp);
    appCheck.activate(
      new firebase.appCheck.ReCaptchaEnterpriseProvider(siteKey),
      true,
    );
    activated = true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[App Check] activate failed:', e);
  }
}

/**
 * @param {boolean} [forceRefresh]
 * @returns {Promise<string|null>} App Check JWT for X-Firebase-AppCheck, or null if unavailable
 */
export async function getAppCheckToken(forceRefresh = false) {
  try {
    const appCheck = firebase.appCheck();
    const result = await appCheck.getToken(forceRefresh);
    return result?.token || null;
  } catch (error) {
    return null;
  }
}
